module.exports = __webpack_public_path__ + "img/gold3.46553ff1.png";